fragment BenefitsPdpFragment on globalBanner_GlobalSet {
  benefitsEnabled
  benefitBlocks {
    ... on benefitBlocksBlock_Entry {
      id
      icon {
        url
        alt
      }
      text
      isMadeInGermany
    }
  }
}

fragment MarketingBannerFragment on globalBanner_GlobalSet {
  marketingBannerEnabled
  showUsps
  uspBarBlocks {
    ... on iconText_Entry {
      svg {
        url
      }
      text
    }
  }
  marketingUspBlocks {
    ... on icon_Entry {
      typeHandle
      svg {
        url
      }
    }
    ... on text_Entry {
      typeHandle
      text
    }
    ... on countdown_Entry {
      typeHandle
      dateTime
    }
    ... on cta_Entry {
      typeHandle
      cta {
        ...LinkFragment
      }
    }
  }
}
